import React from "react";
import { Link } from "react-router-dom";
import Marquee from "react-fast-marquee";
import { SectionHeading } from "./WhatBringsYouHere";

// Slugs must match `/v1/products?brand=<slug>` (mirrors the old UI's
// `topBrands` in apps/web/src/data/catalog.js). Also present in the client
// manifest so brand PLPs can populate from image-derived products.
// Logo files ship in /public/brands (copied from apps/web/public/brands).
const BRANDS = [
  { slug: "3m-espe", name: "3M ESPE", logo: "/brands/3m-espe.svg" },
  { slug: "gc", name: "GC", logo: "/brands/gc.svg" },
  { slug: "nsk", name: "NSK", logo: "/brands/nsk.svg" },
  { slug: "ivoclar-vivadent", name: "Ivoclar Vivadent", logo: "/brands/ivoclar-vivadent.svg" },
  { slug: "dentsply", name: "Dentsply", logo: "/brands/dentsply.svg" },
  { slug: "kerr", name: "Kerr", logo: "/brands/kerr.svg" },
  { slug: "coltene-whaledent", name: "Coltene", logo: "/brands/coltene-whaledent.svg" },
  { slug: "mani", name: "MANI", logo: "/brands/mani.svg" },
  { slug: "woodpecker", name: "Woodpecker", logo: "/brands/woodpecker.svg" },
  { slug: "waldent", name: "Waldent", logo: "/brands/waldent.svg" },
  { slug: "septodont", name: "Septodont", logo: "/brands/septodont.svg" },
  { slug: "prime-dental", name: "Prime Dental", logo: "/brands/prime-dental.svg" },
];

export default function TopBrands() {
  return (
    <section className="dyntra-container mt-10">
      <SectionHeading title="Top Brands" href="/brands" testid="brands-heading" />
      <div className="mt-6 rounded-2xl border border-gray-100 bg-white p-5 shadow-[0_2px_10px_rgba(0,0,0,0.04)]">
        <Marquee gradient={true} gradientColor="#FFFFFF" gradientWidth={60} speed={40} pauseOnHover>
          {BRANDS.concat(BRANDS).map((b, i) => (
            <Link
              key={`${b.slug}-${i}`}
              to={`/brand/${b.slug}`}
              data-testid={i < BRANDS.length ? `brand-${b.slug}` : undefined}
              aria-label={`Shop ${b.name}`}
              className="group flex items-center justify-center min-w-[160px] h-20 mx-3 rounded-xl border border-gray-100 bg-white hover:border-[#4B2AAD]/30 hover:bg-[#F3EFFC] transition-all"
            >
              <img
                src={b.logo}
                alt={b.name}
                loading="lazy"
                onError={(e) => {
                  const el = e.currentTarget;
                  if (!el.dataset.fallback && b.logo.endsWith(".svg")) {
                    el.dataset.fallback = "1";
                    el.src = b.logo.replace(/\.svg$/, ".png");
                  }
                }}
                className="max-h-14 max-w-[130px] object-contain group-hover:opacity-90 transition-opacity"
              />
            </Link>
          ))}
        </Marquee>
      </div>
    </section>
  );
}
